<template>
  <v-btn icon flat small @click="goRoute">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
      <span>Ver</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goRoute () {
      this.$router.push({ name: 'detalleEvento', params: { id: this.item.pk } })
    }
  }
}
</script>
